import axios from "axios";
import { axiosConfig } from "../../config";
import {
    DELEGATE_ADDED,
    DELEGATE_FETCHED,
    DELEGATE_EDITED,
    DELEGATE_REMOVED,
    CURRENT_DELEGATE
} from "../types";
import { setServerErrors } from "./common";

export const getDelegate = () => (dispatch: any) => {
    axios.get(`/api/delegation/getalldelegate`, axiosConfig).then((res) => {
        dispatch({
            type: DELEGATE_FETCHED,
            delegateData: res.data
        });
    }).catch((err) => {
        console.error(err);
    });
};

export const getDelegated = (delegatedBy: string) => (dispatch: any) => {
    axios.get(`/api/delegation/${delegatedBy}`, axiosConfig).then((res) => {
        dispatch({ type: DELEGATE_FETCHED, delegate: res.data.delegate });
    }).catch((err) => {
        console.error(err);
    });
};

export const addDelegate = (values: any) => (dispatch: any, getState: any) => {
    const delegatedBy = sessionStorage.getItem("loggedinUser");
    const delegateData = {
        delegatedTo: values.oracleId,
        delegatedBy: delegatedBy,
        startDate: values.startDate,
        endDate: values.endDate,
    };

    return new Promise((resolve, reject) => {
        axios.post(`/api/delegation/addDelegate`, delegateData, axiosConfig).then((_res) => {
            dispatch({ type: DELEGATE_ADDED });
            dispatch(getDelegate());
            resolve(true);
        }).catch((err) => {
            dispatch(setServerErrors(err.response.data));
            reject(err.response.data);
        });
    });
};

export const editDelegate = (delegationId: string, delegatedTo: string) => (dispatch: any) => {
    axios.put(`/api/delegation/${delegationId}`, {
        delegatedTo
    }, axiosConfig).then((_res) => {
        dispatch({ type: DELEGATE_EDITED });
        dispatch(getDelegate());
    }).catch((err) => {
        console.error(err);
    });
};
export const removeDelegate = (delegationId: string) => (dispatch: any) => {
    axios.delete(`/api/delegation/${delegationId}`, axiosConfig).then((_res) => {
        dispatch({ type: DELEGATE_REMOVED });
        dispatch(getDelegate());
    }).catch((err) => {
        console.error(err);
    });
};

export const setCurrentDelegate = (delegate: any) => {
    return { type: CURRENT_DELEGATE, delegate };
};



